import React, { useState, useEffect } from 'react';

import { arrayMoveImmutable } from 'array-move';
import { SketchPicker } from 'react-color';

import { connect, useSelector, useDispatch } from 'react-redux';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import reactCSS from 'reactcss';
import {
  Button,
  message,
  Layout,
  Input,
  Typography,
  Select,
  Checkbox,
  Spin,
  Modal,
  Tooltip,
  Popover,
} from 'antd';
import {
  MenuOutlined,
  EditOutlined,
  BgColorsOutlined,
  InfoCircleTwoTone,
  EyeTwoTone,
  EyeInvisibleOutlined,
  TransactionOutlined,
  HolderOutlined,
  EyeOutlined,
  EllipsisOutlined,
} from '@ant-design/icons';
import {
  cardInfo,
  handleAppearanceData,
  handleReportOptions,
  handleSortListData,
} from './report_actions';
import ColorPicker from './colorPicker';
import { options } from 'less';

const { Text, Title } = Typography;
const { Option } = Select;

export default ({}) => {
  const dispatch = useDispatch();
  const sortListData = useSelector((state) => state.report.sortListData);
  const initialSortListData = useSelector(
    (state) => state.report.initialSortListData
  );
  const reportOptions = useSelector((state) => state.report.reportOptions);
  // const cardInfo = useSelector((state) => state.report.cardInfo);
  // const report = useSelector((state) => state.report);
  let items = useSelector((state) => state.report.handleAppearanceData);
  // console.log('\n\n card info is here ', report);
  const [dataSource, setDataSource] = useState([]);
  const [hiddenFields, setHiddenFields] = useState([]);

  const [inputField, setInputField] = useState('');
  const [allowNext, setAllowNext] = useState(false);

  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showEditField, setShowEditField] = useState(false);
  const [colorPickerField, setColorPickerField] = useState(null);

  const [currentColor, setCurrentColor] = useState('');
  const [showAddFieldModal, setShowAddFieldModal] = useState(false);
  const [addedField, setAddedField] = useState([]);
  const [displayColorPicker, openPicker] = useState(false);
  // const [isOpen, ] = useState(false);

  const defaultColors = [
    '#B399FE',
    '#25CDA5',
    '#33B6E0',
    '#3F8EEB',
    '#58C8D8',
    '#6EA0DA',
    '#82E3AB',
    '#845FD8',
    '#BAAFF3',
    '#D066D7',
    '#D93C95',
    '#F35074',
    '#FA9B65',
    '#FC7E91',
    '#FFC849',
  ];

  useEffect(() => {
    // console.log(dataSource, sortListData)
    // let items = report && report.handleAppearanceData;
    let filteredData = items && items.filter((data) => data && !data.isHidden);
    if (filteredData) setDataSource(filteredData);
    else if (sortListData && sortListData.dataSource) {
      setDataSource(
        sortListData && sortListData.dataSource ? sortListData.dataSource : []
      );
    } else {
      setDataSource([]);
    }
    // console.log('hiddenFields', hiddenFields)
    // console.log('sortListData', sortListData)
    setHiddenFields(
      sortListData && sortListData.hiddenFields ? sortListData.hiddenFields : []
    );
  }, [sortListData]);
  // console.log('sort list fields ', hiddenFields, dataSource, addedField)

  const onSortEnd = ({ oldIndex, newIndex }) => {
    let newDataSouce = arrayMoveImmutable(dataSource, oldIndex, newIndex);
    for (let i = 0; i < newDataSouce.length; i++) {
      newDataSouce[i].position = i;
    }
    if (
      reportOptions &&
      reportOptions.series &&
      reportOptions.series[0] &&
      reportOptions.series[0].data
    ) {
      let newReport = reportOptions;
      newReport.series[0].data = newDataSouce;
      newReport.xAxis.categories =
        (newDataSouce &&
          newDataSouce.map((d) =>
            d && d.updatedName ? d.updatedName : d && d.name
          )) ||
        [];
      // setReportOptions(newReport);
      setDataSource(newDataSouce);
      dispatch(handleReportOptions(newReport));
      dispatch(
        handleSortListData({ ...sortListData, dataSource: newDataSouce })
      );
      dispatch(handleAppearanceData([...newDataSouce, ...hiddenFields]));
      // setIsLoadingActive(false);
    }
    // console.log('compare, ', dataSource, newDataSouce);
  };
  // const [dataSource, setDataSource] = useState(sortListData.dataSource)

  const handleDeleteField = (value, isHidden, e) => {
    let updatedData = [...dataSource, ...hiddenFields].map((data) => {
      if (data.id === value.id) {
        // data.color = document.getElementById(value.name).value;
        data.isHidden = isHidden;
        return data;
      } else return data;
    });
    // console.log('\n\n isHidden is here 1  \n\n ', updatedData)
    let filteredData = updatedData.filter((item) => item && !item.isHidden);
    for (let i = 0; i < filteredData.length; i++) {
      filteredData[i].position = i;
    }
    filteredData.sort((a, b) => a.position - b.position);
    // console.log('FILTER DATA', filteredData);
    setHiddenFields([...updatedData.filter((item) => item && item.isHidden)]);
    dispatch(
      handleSortListData({
        ...sortListData,
        dataSource: filteredData,
        hiddenFields: [...updatedData.filter((item) => item && item.isHidden)],
      })
    );
    setDataSource(filteredData);
    // console.log('\n\n isHidden is here 2  \n\n ', updatedData, '\n\n ', [...updatedData,...hiddenFields,])
    dispatch(handleAppearanceData([...updatedData]));
    if (
      reportOptions &&
      reportOptions.series &&
      reportOptions.series[0] &&
      reportOptions.series[0].data
    ) {
      let newReport = reportOptions;
      newReport.series[0].data = filteredData;
      newReport.xAxis.categories =
        (filteredData && filteredData.map((d) => d && d.name)) || [];
      // console.log(newReport);
      // setReportOptions(newReport);
    }
    // setIsLoadingActive(false);
  };

  const handleFieldNameChange = (value) => {
    // setIsLoadingActive(true);
    // console.log('bye');
    let dataWithUpdatedName = dataSource.map((data) => {
      if (data.id == value.id) {
        data.updatedName = document.getElementById(value.id).value;
        delete data.isEdit;
      }
      return data;
    });

    if (
      reportOptions &&
      reportOptions.series &&
      reportOptions.series[0] &&
      reportOptions.series[0].data
    ) {
      let newReport = reportOptions;
      newReport.series[0].data = dataWithUpdatedName;
      newReport.xAxis.categories =
        (dataWithUpdatedName &&
          dataWithUpdatedName.map((d) =>
            d && d.updatedName ? d.updatedName : d && d.name
          )) ||
        [];
      // setReportOptions(newReport);
    }
    setDataSource(dataWithUpdatedName);
    dispatch(
      handleSortListData({ ...sortListData, dataSource: dataWithUpdatedName })
    );

    dispatch(handleAppearanceData([...dataWithUpdatedName, ...hiddenFields]));
    // setIsLoadingActive(false);
  };
  const handleEnableEditName = (value) => {
    // console.log('hello');
    let dataWithUpdatedName = dataSource.map((data) => {
      if (data.id == value.id) {
        data.isEdit = true;
      }
      return data;
    });
    setDataSource(dataWithUpdatedName);
  };
  const handleClick = () => {
    openPicker(!displayColorPicker);
  };

  const handleColorChangeinCharts = (color, value, isOpen) => {
    // console.log(
    //   color,
    //   value,
    //   index /* document.getElementById(value.name).value */
    // );

    let updatedData = dataSource.map((data) => {
      if (data.id === value.id) {
        // data.color = document.getElementById(value.name).value;
        data.color = color;
        return data;
      } else return data;
    });
    setDataSource(updatedData);

    dispatch(handleAppearanceData([...updatedData, ...hiddenFields]));
  };

  const handleColorChange = (item) => {
    // console.log('handle item ', item);
    let visible = !showColorPicker;
    setColorPickerField(visible ? item : null);
    setShowColorPicker(visible);
  };

  const handleAddField = () => {
    setShowAddFieldModal(true);
  };

  const handleAddFieldSubmit = () => {
    // setIsLoadingActive(true);
    let newhiddenFields = [];
    let newData = hiddenFields
      .map((item) => {
        if (addedField.includes(item.id)) {
          delete item.isHidden;
        }
        delete item.position;
        if (item.isHidden) newhiddenFields.push(item);
        return item;
      })
      .filter((item) => !item.isHidden);

    setHiddenFields(newhiddenFields);
    let filteredData = [...dataSource, ...newData]; /* .sort(
      (a, b) => a.position - b.position
    ); */

    for (let i = 0; i < filteredData.length; i++) {
      filteredData[i].position = i;
    }
    filteredData.sort((a, b) => a.position - b.position);
    if (
      reportOptions &&
      reportOptions.series &&
      reportOptions.series[0] &&
      reportOptions.series[0].data
    ) {
      let newReport = reportOptions;
      newReport.series[0].data = filteredData;
      newReport.xAxis.categories =
        (filteredData &&
          filteredData.map((d) =>
            d && d.updatedName ? d.updatedName : d && d.name
          )) ||
        [];
      // setReportOptions(newReport);
      dispatch(handleReportOptions(newReport));
    }
    setDataSource([...filteredData]);
    dispatch(handleAppearanceData([...filteredData, ...newhiddenFields]));
    setAddedField([]);
    setShowAddFieldModal(false);
    dispatch(
      handleSortListData({
        ...sortListData,
        dataSource: [...filteredData],
        hiddenFields: [...newhiddenFields],
      })
    );
    setDataSource(filteredData);

    // dispatch(handleAppearanceData([...filteredData]));
  };

  // The initialSortListData is mainly used to reset the display options to the saved state. Currently reset is implemented as a complete clear all button. If needed change it accordingly.
  const handleResetFields = () => {
    const initialDataSource = JSON.parse(
      JSON.stringify(initialSortListData?.dataSource || [])
    );
    const initialHiddenFields = JSON.parse(
      JSON.stringify(initialSortListData?.hiddenFields || [])
    );
    const updatedHiddenFields = initialHiddenFields.map(
      ({ isHidden, ...rest }) => rest
    );
    let filteredData = [...initialDataSource, ...updatedHiddenFields];
    for (let i = 0; i < filteredData.length; i++) {
      filteredData[i].position = i;
    }
    filteredData.sort((a, b) => a.position - b.position);
    if (
      reportOptions &&
      reportOptions.series &&
      reportOptions.series[0] &&
      reportOptions.series[0].data
    ) {
      let newReport = reportOptions;
      newReport.series[0].data = filteredData;
      newReport.xAxis.categories =
        (filteredData &&
          filteredData.map((d) =>
            d && d.updatedName ? d.updatedName : d && d.name
          )) ||
        [];
      dispatch(handleReportOptions(newReport));
    }
    setHiddenFields([]);
    setDataSource(filteredData);
    setAddedField([]);

    dispatch(
      handleSortListData({
        ...initialSortListData,
        dataSource: filteredData,
        hiddenFields: [],
      })
    );

    dispatch(handleAppearanceData(filteredData));
  };

  const DragHandle = SortableHandle(() => {
    return (
      <HolderOutlined
        // <EllipsisOutlined
        //   rotate={90}
        style={{
          cursor: 'grab',
          color:
            localStorage.getItem('theme') == 'default'
              ? 'rgba(0, 0, 0, 0.45)'
              : 'grey',
          fontSize: 16,
        }}
      />
    );
  });

  const truncateString = (data, truncateLength = 30) => {
    if (data.length > truncateLength)
      data = data.slice(0, truncateLength) + '...';
    return data;
  };

  const SortableItem = SortableElement(({ value, index, inputF }) => {
    const [input, setInput] = useState(
      value.updatedName ? value.updatedName : value.name
    );
    const styles = reactCSS({
      default: {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: value.color,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '40px',
          marginBottom: '4px',
          alignItems: 'center',
          // position: 'relative',
          // zIndex: '9',
        }}
        index={index}
      >
        {/* {colorPickerField &&  colorPickerField.id && colorPickerField.id == value.id &&
          <div style={{position:'absolute',
          zIndex: '10',
           marginTop:'-350px' }}>
    
    
    <SketchPicker
              style={{ width: '100%', heigth: '100%' , zIndex: '10', }}
              color={currentColor}
              presetColors={defaultColors}
              onChange={(color) => {
                setCurrentColor(color.hex);
              }}
              onChangeComplete={(color) => {
                // setCurrentColor(color.hex);
                handleColorChangeinCharts(color.hex, inputField);
              }}
              />
              </div>
              } */}
        <DragHandle />

        {/* <Popover
          placement="topLeft"
          title="test"
          content={<><SketchPicker
            style={{ width: '100%', heigth: '100%' , zIndex: '10', }}
            color={value.color}
            presetColors={defaultColors}
            onChange={(color) => {
              setCurrentColor(color.hex);
            }}
            onChangeComplete={(color) => {
              // setCurrentColor(color.hex);
              handleColorChangeinCharts(color.hex, inputField);
            }}
            /></>}
          trigger="click"
        > */}

        {/* <div
              style={{
                backgroundColor: value && value.color ? value.color : '#B399FE',
                // marginLeft: 8,
                // border: 'none',
                // fontSize: 16,
                // width: '32px',
                // hieght: '32px',
             
              }}
              onClick={()=>handleClick()}
              // icon={<BgColorsOutlined />}
              // onClick={() => {
              //   handleColorChange(value);
              //   setInputField(value);
              //   setCurrentColor(value.color);
              // }}
            >


<div> */}
        {/* <div style={ styles.swatch } onClick={ ()=>handleClick ()}>
          <div style={{  backgroundColor: value && value.color ? value.color : '#B399FE'}}/>
     
        { displayColorPicker ? <div style={ styles.popover }>
         <div style={ styles.cover } onClick={ ()=>handleClick() }/> 
          <SketchPicker color={ value.color }  onChange={(color) => {
   // setCurrentColor(color.hex);
   handleColorChangeinCharts(color.hex, value);
 }}/>
        </div> : null }

   
              
             <span
                style={{ display: 'flex', justifyContent: 'center' }}
               
              >
                <BgColorsOutlined />
              </span> 
              
</div>  */}
        <ColorPicker
          value={value}
          updatedData={dataSource}
          hiddenFields={hiddenFields}
          changeColor={handleColorChangeinCharts}
        />

        {/* </Tooltip> */}
        {/* </Popover> */}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginLeft: 8,
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <Input
            style={{
              minWidth: 50,
              width: '100%',
              // margin: 8,
              // marginTop: 0,
              // marginBottom: 16,
            }}
            readOnly={!value.isEdit}
            onChange={(val) => {
              setInput(val.target.value);
            }}
            value={input}
            id={value.id}
          />

          {/* <div>{value.description}</div> */}
          <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <div style={{ fontSize: 16, alignItems: 'center' }}>
              {value && value.isEdit ? (
                <span
                  style={{
                    marginRight: 8,
                    marginLeft: 8,
                  }}
                >
                  <Button
                    onClick={() => {
                      // setInput(value.updatedName ? value.updatedName : value.name);
                      // value && value.isEdit
                      handleFieldNameChange(value);
                      // : handleEnableEditName(value);
                    }}
                  >
                    {/* <div>{value.isEdit ? 'Save' : <EditOutlined />}</div> */}
                    <div>Save</div>
                  </Button>
                </span>
              ) : (
                <EditOutlined
                  style={{
                    marginRight: 8,
                    marginLeft: 8,
                    color:
                      localStorage.getItem('theme') == 'default'
                        ? 'rgba(0, 0, 0, 0.45)'
                        : 'grey',
                  }}
                  onClick={() => {
                    setInput(
                      value.updatedName ? value.updatedName : value.name
                    );
                    handleEnableEditName(value);
                  }}
                />
              )}
            </div>
            <span
              style={{
                fontSize: 16,
                color:
                  localStorage.getItem('theme') == 'default'
                    ? 'rgba(0, 0, 0, 0.45)'
                    : 'grey',
              }}
              /* onClick={(e) => {
                value.isHidden
                  ? handleDeleteField(value, false, e)
                  : handleDeleteField(value, true, e);
              }} */
            >
              {value.isHidden ? (
                <EyeInvisibleOutlined
                  onClick={(e) => {
                    handleDeleteField(value, false);
                  }}
                />
              ) : (
                <EyeOutlined
                  onClick={(e) => {
                    handleDeleteField(value, true);
                  }}
                />
              )}
            </span>
          </div>

          {/* <div> {value.price} </div> */}
        </div>
      </div>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 400,
          // maxHeight:322,
          marginBottom: 16,
          zIndex: -1,
        }}
      >
        {items && items.length > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '8px',
            }}
          >
            <Text strong style={{ marginLeft: 3, marginBottom: 5 }}>
              Customize color and order
            </Text>
            <Button
              onClick={handleResetFields}
              size='small'
              style={{ width: 60, marginRight: 3 }}
            >
              Reset
            </Button>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            // overflowY: 'scroll',
            paddingRight: 10,

            zIndex: '8',
            position: 'relative',
            // marginLeft: 16,
            // marginRight: 16,
          }}
        >
          {items &&
            Array.isArray(items) &&
            items
              .sort((a, b) => a.position - b.position)
              .map((value, index) => (
                <SortableItem
                  value={value}
                  index={index}
                  // key={`sortableItem${value.id}`}
                />
              ))}
        </div>
      </div>
    );
  });

  return (
    <>
      {/* {colorPickerField &&  colorPickerField.id &&<div style={{position:'absolute',zIndex: '10', marginTop:'-400px' }}>
    
    
    <SketchPicker
              style={{ width: '100%', heigth: '100%' , zIndex: '10', }}
              color={currentColor}
              colors={defaultColors}
              onChange={(color) => {
                setCurrentColor(color.hex);
              }}
              onChangeComplete={(color) => {
                // setCurrentColor(color.hex);
                handleColorChangeinCharts(color.hex, inputField);
              }}
              />
              </div>
              } */}

      {dataSource && dataSource.length > 0 ? (
        <SortableList
          items={dataSource}
          onSortEnd={onSortEnd}
          keyboardSortingTransitionDuration={0}
          useDragHandle={true}
          shoudlCancelStart={true}
          onDragEnter={(e) => {
            e.preventDefault();
          }}
        />
      ) : (
        'No Data Found'
      )}
      <Modal
        title='Add Field'
        // footer={null}
        okText='Save'
        centered
        visible={showAddFieldModal}
        onOk={() => handleAddFieldSubmit()}
        onCancel={() => {
          setShowAddFieldModal(false);
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <Text>Select field</Text>
        </div>
        <Select
          mode='multiple'
          style={{ width: '100%' }}
          placeholder='select option'
          value={addedField}
          onChange={(value, data) => {
            setAddedField(value);
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          showArrow
        >
          {hiddenFields &&
            hiddenFields.map((item) => (
              <Option value={item.id} data={item} key={`add${item.id}`}>
                {item.name}
              </Option>
            ))}
        </Select>
      </Modal>

      {hiddenFields && hiddenFields.length > 0 && (
        <Button
          style={{ marginLeft: '10px', marginBottom: 16 }}
          onClick={() => {
            handleAddField();
          }}
        >
          + Add another field
        </Button>
      )}
      {/* {showColorPicker && (
        <Modal
          title='Select color'
          // footer={null}
          okText='Save'
          centered
          visible={showColorPicker}
          onOk={() => {
            handleColorChangeinCharts(currentColor, inputField);
            setShowColorPicker(false);
          }}
          onCancel={() => {
            setShowColorPicker(false);
          }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <SketchPicker
              style={{ width: '100%', heigth: '100%' }}
              color={currentColor}
              colors={defaultColors}
              onChangeComplete={(color) => {
                setCurrentColor(color.hex);
              }}
            />
          </div>
        </Modal>
      )} */}
    </>
  );
};

// width:'100vw',
// height:'100vh',
// backgroundColor:'transparent',
// zIndex: '10',
//  marginTop:'210px',
//  paddingLeft:40,
//  marginLeft:-40
